import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import { secretKey } from "../.././data";
import SelectSearch from "react-select-search";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const AddPayment = (props) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [mail, setMail] = useState("");
  const [bankAcc, setBankAcc] = useState(
    props.mode === "edit" ? props.payment.bank_acc : ""
  );
  const [brand, setBrand] = useState(
    props.mode === "edit" ? props.payment.company : "KPPP"
  );
  const [firstPayDate, setFirstPayDate] = useState(
    props.mode === "edit" ? props.payment.first_payment_date : ""
  );
  const [type, setType] = useState(
    props.mode === "edit" ? props.payment.type : "Opłata wstępna"
  );
  const [bill, setBill] = useState(
    props.mode === "edit" ? parseFloat(props.payment.to_settlement) : ""
  );
  const [installmentCount, setInstallmentCount] = useState(
    props.mode === "edit" ? props.payment.installment : ""
  );
  const [clientsE, setClientsE] = useState(
    props.mode === "edit" ? props.payment.name.split(",") : []
  );
  const [phoneE, setPhoneE] = useState(
    props.mode === "edit" ? props.payment.phone.split(",") : []
  );
  const [mailE, setMailE] = useState(
    props.mode === "edit" ? props.payment.email.split(",") : []
  );
  const [loading, setLoading] = useState(true);
  const [client, setClient] = useState(
    props.mode === "main" ? "" : props.client
  );
  const [clientId, setClientId] = useState("");
  const [clients, setClients] = useState([]);
  const [clientsSygn, setClientsSygn] = useState([]);
  const [clientsOptions, setClientsOptions] = useState([]);
  const [payed, setPayed] = useState(
    props.mode === "edit"
      ? +props.payment.to_settlement === +props.payment.pay_sum
        ? true
        : false
      : false
  );

  const fetchClients = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsListAddDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data).filter((el) => el.arch === "0");
        setClients(data);
        setClientsOptions(createClientsOptions(data));
      })
      .catch((error) => {});
  };

  const fetchClientsAll = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsListAddDateAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data).filter((el) => el.arch === "0");
        setClients(data);
        setClientsOptions(createClientsOptions(data));
      })
      .catch((error) => {});
  };

  const getAllowedClients = (data) => {
    if (props.user.allowedClients === "all") {
      return data;
    } else {
      var allowed = props.user.allowedClients
        .toString()
        .replaceAll(" ", "")
        .split(",");
      var arr = [];
      allowed.map((el) => {
        arr = arr.concat(data.filter((el2) => +el2.id === +el));
      });
      return arr;
    }
  };

  const fetchClientsSygn = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsSygn", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsSygn(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    if (props.modePlace === "client") {
      setClient(props.clientData);
      setLoading(false);
    } else {
      if (props.team === 0) {
        fetchClientsAll();
      } else {
        fetchClients();
      }
      fetchClientsSygn();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleDeleteClient = (e) => {
    var newArray = [];
    if (props.mode === "edit") {
      newArray = clientsE.filter((el) => el !== e.target.value);
    } else {
      newArray = clientsE.filter((el) => el.id !== +e.target.value);
    }
    setClientsE(newArray);
  };
  const handleDeletePhone = (e) => {
    var newArray = [];
    if (props.mode === "edit") {
      newArray = phoneE.filter((el) => el !== e.target.value);
    } else {
      newArray = phoneE.filter((el) => el.id !== +e.target.value);
    }
    setPhoneE(newArray);
  };
  const handleDeleteMail = (e) => {
    var newArray = [];
    if (props.mode === "edit") {
      newArray = mailE.filter((el) => el !== e.target.value);
    } else {
      newArray = mailE.filter((el) => el.id !== +e.target.value);
    }
    setMailE(newArray);
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };

  const handleMailChange = (e) => {
    setMail(e.target.value);
  };

  const handleBankAccChange = (e) => {
    setBankAcc(e.target.value);
  };

  const handleBrandChange = (e) => {
    setBrand(e.target.value);
  };

  const handleFirstPayDateChange = (e) => {
    setFirstPayDate(e.target.value);
  };

  const handleTypeChange = (e) => {
    setType(e.target.value);
  };

  const handleBillChange = (e) => {
    setBill(e.target.value);
  };

  const handleInstallmentCountChange = (e) => {
    setInstallmentCount(e.target.value);
  };

  const generateName = () => {
    var name = "";
    if (props.mode === "edit") {
      for (var i = 0; i < clientsE.length; i = i + 1) {
        name = name + clientsE[i] + (i === clientsE.length - 1 ? "" : ", ");
      }
    } else {
      for (var i = 0; i < clientsE.length; i = i + 1) {
        name =
          name + clientsE[i].name + (i === clientsE.length - 1 ? "" : ", ");
      }
    }
    return name;
  };

  const generatePhone = () => {
    var name = "";
    if (props.mode === "edit") {
      for (var i = 0; i < phoneE.length; i = i + 1) {
        name = name + phoneE[i] + (i === phoneE.length - 1 ? "" : ", ");
      }
    } else {
      for (var i = 0; i < phoneE.length; i = i + 1) {
        name = name + phoneE[i].phone + (i === phoneE.length - 1 ? "" : ", ");
      }
    }
    return name;
  };

  const generateMail = () => {
    var name = "";
    if (props.mode === "edit") {
      for (var i = 0; i < mailE.length; i = i + 1) {
        name = name + mailE[i] + (i === mailE.length - 1 ? "" : ", ");
      }
    } else {
      for (var i = 0; i < mailE.length; i = i + 1) {
        name = name + mailE[i].mail + (i === mailE.length - 1 ? "" : ", ");
      }
    }
    return name;
  };

  const editPayment = async (e) => {
    if (validatePayment()) {
      setLoading(true);
      var body = {
        name: generateName().replaceAll("  ", " ").replaceAll("   ", " "),
        phone: generatePhone(),
        email: generateMail(),
        first_payment_date: firstPayDate,
        identifier: props.payment.identifier,
        type: type,
        to_settlement: bill,
        installment: installmentCount,
      };

      await fetch("https://apidevkppp.ftpeople.pl/editPayment", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then(async (data) => {
          MySwal.fire({
            icon: "success",
            title: props.mode === "edit" ? "Edytowano" : "Dodano",
            text: "rozliczenie",
          }).then(async (result) => {
            props.close();
          });
          return;

          await fetch(
            "https://apidevkppp.ftpeople.pl/getTransactionsAssigned",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            }
          )
            .then((response) => response.json())
            .then((data) => {
              checkPayments(data);
            })
            .catch((error) => {});
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const addPayment = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        name: client.petitioner,
        phone: client.phone === undefined ? "" : client.phone,
        email: client.email === undefined ? "" : client.email,
        first_payment_date: firstPayDate,
        company: brand,
        type: type,
        to_settlement: bill,
        installment: installmentCount,
        clientId: client.id,
        payed: payed ? "1" : "0",
        client: client,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addPayment", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then((data) => {})
        .catch((error) => {});

      MySwal.fire({
        icon: "success",
        title: props.mode === "edit" ? "Edytowano" : "Dodano",
        text: "rozliczenie",
      }).then(async (result) => {
        props.close();
      });
      return;

      await fetch("https://apidevkppp.ftpeople.pl/getTransactionsAssigned", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          checkPayments(data);
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const checkExpectedTransactionsCount = (
    dateOfStartPayment,
    installmentCount
  ) => {
    var now = new Date();
    var startDate = new Date(dateOfStartPayment);
    var months = (now.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += now.getMonth();
    return months <= 0
      ? 0
      : months > installmentCount
      ? installmentCount
      : months;
  };

  const getDelayTime = (dateOfStartPayment, pay_sum, expected_pay_count) => {
    var startDate = new Date(dateOfStartPayment);
    var now = new Date();
    var lastPaymentDateForDelay = new Date(
      startDate.setMonth(startDate.getMonth() + pay_sum)
    );
    var delay_days = days(now, lastPaymentDateForDelay);
    return delay_days < 0 ? 0 : delay_days;
  };

  const days = (date_1, date_2) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return TotalDays;
  };

  const checkPayments = async (transactions) => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data
          .filter((el) => !el.archive_date)
          .map(async (el) => {
            var transactionsForPayment = transactions.filter(
              (tr) => tr.payId === el.identifier
            );
            transactionsForPayment.sort(function (a, b) {
              return new Date(b.date) - new Date(a.date);
            });
            var pay_sum = 0;
            for (var i = 0; i < transactionsForPayment.length; i += 1) {
              pay_sum =
                parseFloat(
                  transactionsForPayment[i].bill.replaceAll(",", ".")
                ) + pay_sum;
            }

            var archive =
              parseInt(el.to_settlement) === parseInt(pay_sum) ? "TAK" : "NIE";
            var bankAcc = el.bank_acc;
            if (transactionsForPayment.length > 0) {
              if (
                !transactionsForPayment[0].title.includes("Wpłata w UP") &&
                !transactionsForPayment[0].client.includes("CINKCIARZ")
              ) {
                bankAcc = transactionsForPayment[0].bank_acc;
              }
            }

            var body2 = {
              identifier: el.identifier,
              pay_sum: pay_sum,
              bank_acc: bankAcc,
              pay_count: transactionsForPayment.length,
              pay_expected_count: checkExpectedTransactionsCount(
                el.first_payment_date,
                el.installment
              ),
              last_pay_date:
                transactionsForPayment.length > 0
                  ? transactionsForPayment[0].date
                  : "",
              is_overdated:
                checkExpectedTransactionsCount(
                  el.first_payment_date,
                  el.installment
                ) > transactionsForPayment.length
                  ? "TAK"
                  : "NIE",
              to_archive:
                parseInt(el.to_settlement.toString().replace(",", ".")) ===
                parseInt(pay_sum.toString().replace(",", "."))
                  ? "TAK"
                  : "NIE",
              delay_time:
                archive === "TAK"
                  ? 0
                  : getDelayTime(
                      el.first_payment_date,
                      transactionsForPayment.length,
                      checkExpectedTransactionsCount(
                        el.first_payment_date,
                        el.installment
                      )
                    ),
            };

            fetch("https://apidevkppp.ftpeople.pl/editPaymentCheck", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body2),
            })
              .then((response) => response.json())
              .then((data) => {})
              .catch((error) => {});
          });
      })
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: props.mode === "edit" ? "Edytowano" : "Dodano",
      text: "rozliczenie",
    }).then(async (result) => {
      props.close();
    });
  };

  const validatePayment = (e) => {
    if (payed) {
      if (client && brand.length > 0 && type.length > 0 && +bill > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        client &&
        brand.length > 0 &&
        firstPayDate.length > 0 &&
        type.length > 0 &&
        +bill > 0 &&
        installmentCount.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  const handleAddClient = (e) => {
    var check = e.target.value.split(" ").length > 1;
    if (check) {
      if (e.target.value === "") {
        return;
      } else {
        if (props.mode === "edit") {
          clientsE.push(e.target.value);
        } else {
          clientsE.push({ id: Math.random() * 100, name: e.target.value });
        }
        setName("");
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Imię i nazwisko niepoprawne",
      });
    }
  };

  const handleAddPhone = (e) => {
    var check = e.target.value.length >= 9;
    if (check) {
      if (e.target.value === "") {
        return;
      } else {
        if (props.mode === "edit") {
          phoneE.push(e.target.value);
        } else {
          phoneE.push({ id: Math.random() * 100, phone: e.target.value });
        }
        setPhone("");
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Zły format numeru telefonu",
      });
    }
  };

  const handleAddMail = (e) => {
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var check = e.target.value.length > 0 && e.target.value.match(validRegex);
    if (check) {
      if (e.target.value === "") {
        return;
      } else {
        if (props.mode === "edit") {
          mailE.push(e.target.value);
        } else {
          mailE.push({ id: Math.random() * 100, mail: e.target.value });
        }
        setMail("");
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Adres e-mail niepoprawny",
      });
    }
  };

  const handleClientChange = (e) => {
    setClientId(e.value);
    setClient(clients.filter((el) => +el.id === +e.value)[0]);
  };

  const getActualSygnForClient = (clientId) => {
    var sygns = clientsSygn.filter((el) => +el.clientId === +clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].sygn.length > 4
        ? sygns[0].sygn
        : "brak danych"
      : "brak danych";
  };

  const createClientsOptions = (data) => {
    var bankOptions = [];
    data.map((el) => {
      bankOptions.push({
        label:
          el.petitioner +
          " | " +
          (data.filter((el2) => el2.id === el.id)[0].aSygn === "brak danych"
            ? el.credit_value
            : data.filter((el2) => el2.id === el.id)[0].aSygn),
        value: el.id,
      });
    });

    return bankOptions;
  };

  return (
    <>
      <div className="mainContainerAddPayment">
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>

            <div id="addPaymentIC" className="inputContainer">
              {props.modeAdd === "main" && props.modePlace !== "client" ? (
                <>
                  <div style={{ width: "66%" }} className="inputBox">
                    <div className="inputCol_1">
                      <label>
                        Klient <span className="requiredStar">*</span>
                      </label>
                      <Select
                        noOptionsMessage={() => "Brak danych"}
                        placeholder={"Wybierz..."}
                        isClearable={false}
                        options={clientsOptions}
                        onChange={handleClientChange}
                      />
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              <div className="inputBox">
                <div className="inputCol_3">
                  <label>Numer konta bankowego</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={bankAcc}
                    onChange={handleBankAccChange}
                  />
                </div>
                <div className="inputCol_3">
                  <label>
                    Marka <span className="requiredStar">*</span>
                  </label>
                  <select
                    type="text"
                    id="court"
                    name="court"
                    value={brand}
                    onChange={handleBrandChange}
                  >
                    <option key={0} value="KPPP">
                      KPPP
                    </option>
                    <option key={1} value="Wygrywamy z bankami">
                      Wygrywamy z bankami
                    </option>
                    <option key={2} value="Anulujemy Kredyt CHF">
                      Anulujemy Kredyt CHF
                    </option>
                    <option key={3} value="Frankowa Kancelaria">
                      Frankowa Kancelaria
                    </option>
                  </select>
                </div>
                {!payed ? (
                  <div className="inputCol_3">
                    <label>
                      Data pierwszej płatności{" "}
                      <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="date"
                      id="name"
                      name="name"
                      value={firstPayDate}
                      onChange={handleFirstPayDateChange}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="inputBox">
                <div className="inputCol_3">
                  <label>
                    Rodzaj <span className="requiredStar">*</span>
                  </label>
                  <select
                    type="text"
                    id="court"
                    name="court"
                    value={type}
                    onChange={handleTypeChange}
                  >
                    <option key={0} value="Opłata wstępna">
                      Opłata wstępna
                    </option>
                    <option key={1} value="Success Fee">
                      Success Fee
                    </option>
                    <option key={2} value="Opłata za rozprawę">
                      Opłata za rozprawę
                    </option>
                    <option key={3} value="KZP I Instancja">
                      KZP I Instancja
                    </option>
                    <option key={4} value="KZP II Instancja">
                      KZP II Instancja
                    </option>
                    <option key={5} value="KZP SN">
                      KZP SN
                    </option>
                    <option key={6} value="Wynagrodzenie za skargę kasacyjną">
                      Wynagrodzenie za skargę kasacyjną
                    </option>
                    <option key={7} value="KZP I i II instancja łącznie">
                      KZP I i II instancja łącznie
                    </option>
                  </select>
                </div>
                <div className="inputCol_3">
                  <label>
                    Kwota rozliczenia <span className="requiredStar">*</span>
                  </label>
                  <input
                    type="number"
                    id="name"
                    name="name"
                    value={bill}
                    onChange={handleBillChange}
                  />
                </div>
                {!payed ? (
                  <div className="inputCol_3">
                    <label>
                      Ilość rat <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="number"
                      id="name"
                      name="name"
                      value={installmentCount}
                      onChange={handleInstallmentCountChange}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
              {props.mode === "edit" ? (
                ""
              ) : (
                <>
                  <div
                    className="multiContainer"
                    style={{ paddingTop: "2vh", width: "100%" }}
                  >
                    <div
                      style={{
                        height: "2.5vh",
                        fontWeight: "300",
                        fontSize: "0.8vw",
                        width: "100%",
                      }}
                      className="checkBox"
                    >
                      <input
                        style={{ height: "2vh" }}
                        id="checkCal2"
                        type="checkbox"
                        checked={payed}
                        onChange={(e) => {
                          setPayed(e.target.checked);
                        }}
                      />
                      Płatność opłacona
                    </div>
                  </div>
                </>
              )}

              <div className="saveBoxAP">
                <button
                  className="paymentMenuButton"
                  onClick={props.mode === "edit" ? editPayment : addPayment}
                >
                  zapisz
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddPayment;
